// generated by genversion
export var version = '4.5.2';
//# sourceMappingURL=version.js.map